import { PROPOSAL_RIDERS } from "../../constant/gms-constant";

export type ProposalProductAcronym = keyof typeof PROPOSAL_PRODUCTS;

export type ProposalRider = (typeof PROPOSAL_RIDERS)[keyof typeof PROPOSAL_RIDERS];

export const PROPOSAL_PRODUCTS = {
    GCLI: {
        id: 1,
        name: 'Group Credit Life Insurance (GCLI)',
        acronym: 'GCLI',
    },
    GYRT: {
        id: 2,
        name: 'Group Term Life Insurance (GYRT)',
        acronym: 'GYRT',
    },
    GPA: {
        id: 3,
        name: 'Group Personal Accident Insurance (GPA)',
        acronym: 'GPA',
    },
    GCI: {
        id: 4,
        name: 'Group Critical Illness (GCI)',
        acronym: 'GCI',
    },
} as const;

export const getRiderId = ( rider: ProposalRider, product: ProposalProductAcronym ): number | undefined => {
    return rider.productFor[product as keyof typeof rider.productFor];
};
